import BaseIcon from '../../../icons/strategyBuilder/BaseIcon'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import React, { useState, useEffect } from 'react'
import GET_TEMPLATE_OVERVIEW, {
  TEMPLATE_CATEGORY,
} from '../../../apollo/queries/GET_TEMPLATE_OVERVIEW'
import { Flex, Text, Image } from 'theme-ui'
import { useQuery } from '@apollo/client'
import { mergeStrategyData } from '../../../utils/strategyBuilder'
import { useStrategyOverviewCards } from '../../../hooks/useStrategyOverviewCards'

const StrategyIcons = () => {
  const [strategyIcons, setStrategyIcons] = useState([])
  const { loading, data: templateData } = useQuery(GET_TEMPLATE_OVERVIEW, {
    variables: { templateCategory: TEMPLATE_CATEGORY.STRATEGY_BUILDER },
  })
  const { overviewCards } = useStrategyOverviewCards()

  useEffect(() => {
    const mergedData = mergeStrategyData({
      overviewCards: overviewCards,
      templateData: templateData?.templatesOverview,
    })
    setStrategyIcons(mergedData)
  }, [templateData, overviewCards])

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        mt: '22px',
      }}
    >
      <Text
        variant="xxSmallText"
        sx={{
          mb: '8px',
          boxSizing: 'border-box',
          margin: 0,
          minWidth: 0,
          fontFamily:
            'Graphik system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
          fontSize: '14px',
          fontWeight: 400,
        }}
      >
        Completed Surveys:
      </Text>
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '10px',
          width: '100%',
        }}
      >
        {!loading &&
          strategyIcons.map(({ name, url, isComplete }, i) => (
            <BaseIcon
              data-automation-id={`${name
                .toLowerCase()
                .replaceAll(' ', '-')}-icon`}
              key={i}
              isComplete={isComplete}
            >
              <Image src={url} />
            </BaseIcon>
          ))}
        {loading &&
          Array(6)
            .fill(0)
            .map((_, i) => (
              <Skeleton
                style={{
                  width: '26px',
                  height: '26px',
                }}
                circle
                key={i}
              />
            ))}
      </Flex>
    </Flex>
  )
}

export default StrategyIcons
